import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { BLOCKS, Document } from '@contentful/rich-text-types';
import * as Sentry from '@sentry/browser';
import parse from 'html-react-parser';

export function getParsedHtmlLangTagList(langTagsList?: Document) {
  if (!langTagsList) return null;

  const richTextOptions = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node: any) => `${node.content[0].value}`,
    },
  };

  // Serialize a Contentful Rich Text `document` to an html string.
  const htmlString = documentToHtmlString(langTagsList, richTextOptions);

  if (!isValidHtmlString(htmlString)) {
    Sentry.addBreadcrumb({
      category: 'HREFLangTag',
      message: 'Error parsing Contentful HREFLangTag(s) - Invalid HTML string',
      level: Sentry.Severity.Warning,
    });
    return;
  }

  // Converts an HTML string to a JSX element.
  return parse(htmlString.split('\n').join(''));
}

export function isValidHtmlString(htmlStr: string) {
  return /<\/?[a-z][\s\S]*>/i.test(htmlStr);
}
